import { LoadmoreSearchData } from "./search/Requests";
import LoadMoreSearch from './search/LoadMoreSearch';
import { LoadMoreCategoryData } from "./category/Requests";
import LoadMoreCategory from './category/LoadMoreCategory';
const Search = {
    loadmore() {
        addEventListener('DOMContentLoaded', () => {
            LoadmoreSearchData.btnLoadmore = document.querySelector('.loadMorePageSearch');
            LoadmoreSearchData.wrapList = document.querySelector('.loadMore_list');
            new LoadMoreSearch(LoadmoreSearchData).start();
        });
    }
};
Search.loadmore();
const loadMoreCategory = {
    loadmore() {
        addEventListener('DOMContentLoaded', () => {
            LoadMoreCategoryData.btnLoadmore = document.querySelector('.loadMoreCategory');
            LoadMoreCategoryData.wrapList = document.querySelector('.loadMore_list');
            new LoadMoreCategory(LoadMoreCategoryData).start();
        });
    }
};
loadMoreCategory.loadmore();
